import { HomeStudentHistoryTable } from './HomeStudentHistoryTable';
export default HomeStudentHistoryTable;
